export default {
    guest: {
        changeLanguage: 'Russian',
        forgotPassword: 'Forgot password?',
        toLogin: 'Login',
        toLoginSSO: 'Login with SSO',
        email: 'Email',
        login: 'Login',
        password: 'Password',
        recoveryPage: 'Password recovery',
        recovery: 'Send',
        reset: 'Send',
        invalidResetToken: 'Invalid link to password reset',
        captchaRefresh: 'Update picture',
        captcha: 'Enter the code from the image',
        OfficeWasCreated: "Employee's My Office was created successfully",
        invalidAuthToken: 'Invalid link to register',
        passwordResetSuccess: 'We have sent you a message to your personal email. Please, click on the link in it and follow the further instructions to reset your password.'
    }
};
